<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card class="elevation-12">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Login form</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="creds.login"
              label="Login"
              prepend-icon="mdi-account"
              type="text"
            ></v-text-field>

            <v-text-field
              v-model="creds.password"
              label="Password"
              prepend-icon="mdi-lock"
              type="password"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="login()">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AuthService from "@/services/auth";
export default {
  name: "Login",
  data: () => ({
    creds: {
      login: "",
      password: ""
    }
  }),
  methods: {
    login() {
      AuthService.login(this.creds).then(resp => {
        var timestamp = Math.round(new Date().getTime() / 1000) + 300;
        localStorage.setItem("accessToken", resp.data.accessToken);
        localStorage.setItem("refreshToken", resp.data.refreshToken);
        localStorage.setItem("tokenExpire", new Date(timestamp * 1000));
      });
    }
  }
};
</script>

<style></style>
